// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"996d6a3d","798":"69573b73","928":"af3a0ba9","996":"fe363b9a"}[chunkId] + ".js";
};